import React from 'react';
import { Footnotes } from '@hpstellar/core';

import { Helpers } from '../../../core/src/helpers';

import './footnotes-disclaimer.less';

const FootnotesDisclaimer = ({ pdpFootnotesDisclaimer, title, accordionProps }) => {
    if (!pdpFootnotesDisclaimer) return null;
    const translations = {
        title,
    };
    const notes = pdpFootnotesDisclaimer.map(disclaimers => ({
        title: disclaimers.section,
        desc: (
            <span
                key={disclaimers.section}
                dangerouslySetInnerHTML={Helpers.createMarkup(
                    disclaimers.disclaimerPoints.map(x => `<span class="point">${x}</span>`).join(''),
                )}
            />
        ),
    }));

    return (
        <div id="footnotesDisclaimer">
            <Footnotes translations={translations} notes={notes} accordionProps={accordionProps} />
        </div>
    );
};

export default FootnotesDisclaimer;
